import { render, staticRenderFns } from "./special-head.vue?vue&type=template&id=43e06f6c&scoped=true"
import script from "./special-head.vue?vue&type=script&lang=js"
export * from "./special-head.vue?vue&type=script&lang=js"
import style0 from "./special-head.vue?vue&type=style&index=0&id=43e06f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e06f6c",
  null
  
)

export default component.exports